import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr/common.json';
import en from './locales/en/common.json';

const STORAGE_KEY = 'mpo.lang';

function initialLang() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'fr' || saved === 'en') return saved;
  } catch {}
  // French is the product's primary language; only default to EN for en-* browsers.
  return navigator.language?.toLowerCase().startsWith('en') ? 'en' : 'fr';
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { common: fr },
    en: { common: en },
  },
  lng: initialLang(),
  fallbackLng: 'fr',
  defaultNS: 'common',
  ns: ['common'],
  interpolation: { escapeValue: false },
});

try { document.documentElement.lang = i18n.language; } catch {}

export const LANGS = ['fr', 'en'];

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  try { localStorage.setItem(STORAGE_KEY, lng); } catch {}
  try { document.documentElement.lang = lng; } catch {}
}

export default i18n;
